module.exports = __webpack_public_path__ + "img/full7-min.02c84e86.png";